import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Import all your files
import DownloadPortal from './DownloadPortal';
import TermsOfUse from './TermsOfUse';
import PrivacyPolicy from './PrivacyPolicy';
import ContactUs from './ContactUs'; // ✨ Import the new Contact Us file

function App() {
  return (
    <Router>
      <Routes>
        {/* The Main Home Page */}
        <Route path="/" element={<DownloadPortal />} />
        
        {/* Multipage routing for other pages */}
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/contact-us" element={<ContactUs />} /> {/* ✨ Add the new route */}
      </Routes>
    </Router>
  );
}

export default App;